import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M4.755 14.5L7 12L4.755 9.5M10 12H20" vectorEffect="non-scaling-stroke" />
	</SVG>
);
